import { createApp } from "vue";
import App from "./ClientApp.vue";
import { createPinia } from "pinia";
import { clickOutsideElement } from "@/directives/ClickOutside";
import axios from "axios";
import VueAxios from "vue-axios";
import { useRenderStore } from "@/builder/stores/renderStore";
import { publicApiService } from "../../services/publicApiService";
import { trackingPixelService } from "../../services/trackingPixelService";
import { googleAnalyticsService } from "@/services/googleAnalyticsService";
import { createHead } from "@unhead/vue";

const embeds = document.querySelectorAll("div[data-rd-page]");
for (let i = 0; i < embeds.length; i++) {
    const embed = embeds[i];
    const pageId = embed.getAttribute("data-rd-page");
    const organizationId = embed.getAttribute("data-organizationId");
    const environment = embed.getAttribute("data-environment");

    const globalAxios = axios.create({
        withCredentials: false,
    });

    const pinia = createPinia();
    const head = createHead();

    const app = createApp(App, {
        pageId: pageId,
        organizationId: organizationId,
        environment: environment,
    })
        .use(pinia)
        // @ts-ignore
        .use(VueAxios, globalAxios)
        .use(head)
        .directive("click-outside", clickOutsideElement);

    const renderStore = useRenderStore();

    renderStore.setEnvironment(environment ?? "production");
    renderStore.setOrganizationId(organizationId ?? "Unknown");

    app.provide("axios", app.config.globalProperties.axios);
    app.provide(
        "publicApiService",
        new publicApiService(renderStore.apiBaseUrl)
    );
    app.provide("trackingPixelService", new trackingPixelService());
    app.provide("googleAnalyticsService", new googleAnalyticsService());

    app.mount("#rd_" + pageId);
}
